const axios = require('axios');

import {VIGEO_URL as baseUrl } from "@/modules/shared/config/config.service"

const RecapitulatifVigeoService = {
    /**
     * Récupère les informations de l'utilisateur
     */
    getUserInformations() {
        const url = baseUrl + '/user'
        return axios.get(url)
    },
    /**
     * Soumets le formulaire
     */
    submitForm(data, params) {
        const url = baseUrl + '/recapitulatif/submit'
        return axios.post(url, data, {params: params})
    },
    /**
     * Fournit l'URL pour télécharger les documents récapitulatifs
     */
    getDownloadDocumentsURL() {
        return baseUrl + '/recapitulatif/documents'
    }
}

export default RecapitulatifVigeoService
